import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';

export const DiscountedFields = ({ disabled }: { disabled: boolean }) => {
  const { getValues, watch } = useFormContext();
  const specialType = watch('special_type');
  const specialTypeSettings =
    specialType === 'spending_threshold'
      ? specialType
      : `${specialType}.settings`;
  const maxDiscountedField = `display.${specialType}.max_number_of_discounted_products`;
  const fieldLabel = 'Maximum products discounted';
  const applyDiscountToRequired = watch(
    `display.${specialTypeSettings}.allow_discounts_on_required_products`
  );

  return (
    <Flex flexDirection="column" gap={24} mt={24}>
      {!disabled ? (
        <Form.NumberField
          width="100%"
          name={maxDiscountedField}
          label={fieldLabel}
          defaultValue={getValues(maxDiscountedField)}
          min={1}
          step={1}
          required
          disableOnWheel
        />
      ) : (
        <Flex width="50%" flexDirection="column">
          <Typography
            color="grays-black"
            variant="body-semibold"
            data-testid="non-janepos-synced-discounted"
          >
            {fieldLabel}
          </Typography>
          <Typography color="grays-black" mt={4}>
            {getValues(maxDiscountedField) || 'N/A'}
          </Typography>
        </Flex>
      )}
      <Form.CheckboxField
        name={`display.${specialTypeSettings}.copy_conditions_for_discounted_products`}
        label="Use same conditions as required products"
        disabled={!!applyDiscountToRequired || disabled}
      />
    </Flex>
  );
};
